<template>
    <edit-enum
        ref="input"
        v-model="inputValue"
        form
        :readonly="readonly"
        :disabled="disabled"
        :required="required"
        :rules="rulesValue"
        :error="error"
        :error-messages="errorMessagesValue"
        :label="labelValue"
        :enums="enums"
        :enum-a11y-key="enumA11yKey"
        :multiple="multiple"
        :hide-details="hideDetails"
        :info="info"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        @keyup="$emit('keyup')"
        @keydown="$emit('keydown')"
        @click="$emit('click')"
        @change="$emit('change')"
    >
        <template v-if="findSlot('item')" #item="attrs">
            <slot name="item" v-bind="attrs" />
        </template>
        <template v-else-if="enumA11yDescriptionKey" #item="{ item }">
            <v-list-item-icon v-if="multiple" class="mr-0">
                <v-icon v-if="inputValue && inputValue.includes(item.value)" dense small>{{
                    getIcon('checkboxOn')
                }}</v-icon>
                <v-icon v-else dense small>{{ getIcon('checkboxOff') }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title class="body-2 primaryText--text">
                    {{ $t(`${enumA11yKey}.${item.value}`) }}
                </v-list-item-title>
                <p class="text--secondary text--small mb-0" style="max-width: 32rem; line-height: 1.3">
                    {{ $t(`${enumA11yDescriptionKey}.${item.value}`) }}
                </p>
            </v-list-item-content>
        </template>
        <template v-else #item="{ item }">
            <v-list-item-icon v-if="multiple" class="mr-0">
                <v-icon v-if="inputValue && inputValue.includes(item.value)" dense small>{{
                    getIcon('checkboxOn')
                }}</v-icon>
                <v-icon v-else dense small>{{ getIcon('checkboxOff') }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>
                    {{ $t(`${enumA11yKey}.${item.value}`) }}
                </v-list-item-title>
            </v-list-item-content>
        </template>
        <template #append-outer>
            <slot name="append-outer" />
        </template>
    </edit-enum>
</template>

<script>
import BaseField from './BaseField';

export default {
    name: 'Enum',
    extends: BaseField,
    props: {
        enums: {
            type: [Object, Array],
            required: true
        },
        enumA11yKey: {
            type: String,
            default: null
        },
        enumA11yDescriptionKey: {
            type: String,
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        }
    }
};
</script>
